export const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export const getRandomItem = (length) => Math.floor(Math.random() * length);

export const blockDelay = 250;
export const nestedDelay = 125;
export const footerDelay = 1250;
export const formDelay = 250;
